import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const LINES = {
  clicks: ["Clicks", "#2f4f3a"],
  likes: ["Likes", "#c2703d"],
  interests: ["Interests", "#84a59d"],
  rsvps: ["RSVPs", "#d4a373"],
};
const monthLabel = (m) => new Date(`${m}-01T00:00:00`).toLocaleString(undefined, { month: "short" });

// 6-month line chart for the analytics metrics.
export default function StatsTrendChart({ data, keys = Object.keys(LINES), height = 240, testid }) {
  return (
    <div style={{ height }} data-testid={testid}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 8, right: 12, left: -16, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e8e2d6" />
          <XAxis dataKey="month" tickFormatter={monthLabel} tick={{ fontSize: 11 }} />
          <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
          <Tooltip labelFormatter={monthLabel} />
          <Legend wrapperStyle={{ fontSize: 11 }} />
          {keys.map((k) => (
            <Line key={k} type="monotone" dataKey={k} name={LINES[k][0]} stroke={LINES[k][1]} strokeWidth={2} dot={{ r: 3 }} />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
